"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeAddTrackAnalyticsListener = exports.addTrackAnalyticsListener = exports.trackAnalytics = void 0;

var trackAnalytics = function trackAnalytics() {
  // CustomEvent not compatible with IE 10.1 and below
  // eslint-disable-next-line
  var evt = new CustomEvent('trackAnalytics', {});
  window.dispatchEvent(evt);
};

exports.trackAnalytics = trackAnalytics;

var addTrackAnalyticsListener = function addTrackAnalyticsListener(eventCallback) {
  return window.addEventListener('trackAnalytics', eventCallback);
};

exports.addTrackAnalyticsListener = addTrackAnalyticsListener;

var removeAddTrackAnalyticsListener = function removeAddTrackAnalyticsListener(eventCallback) {
  return window.removeEventListener('trackAnalytics', eventCallback);
};

exports.removeAddTrackAnalyticsListener = removeAddTrackAnalyticsListener;